import {
  getCurrentToken,
  getRegion,
  getEnv,
  getPartition,
} from '@adsk/acs-sc-web-platform-api';
import { DocsClass, DOCS_PRODUCTS } from '@adsk/docs-js-sdk';

const getSDK = () => {
  const instance = new DocsClass({
    region: getRegion(),
    env: getEnv(),
    partition: getPartition(),
    getToken: getCurrentToken,
    buildId: 'alloy_attachment',
    product: DOCS_PRODUCTS.ACC,
  });
  return instance;
};

export const { DerivativeService, Folders, Documents, Upload } = getSDK();
